import { Skeleton } from 'antd';
import { Role } from 'features/auth/types';
import { useAppSelector } from 'lib/store/rootReducer';
import { useGetPatientInfo } from '../_utils/patient-info/hook-context-patientinfo';
import { PatientHomeAssessmentBlockedV1Dot2 } from './components/assessment-blocked/assessment-blocked';
import { PatientHomeClinician } from './components/patient-home-clinician/patient-home-clinician';
import { PatientHomeAssessmentUnblocked } from './components/assessment-unblocked';
import { PatientHomeLayout } from './layout';
import { BaseHeader } from 'components/header';

export function PatientHomeWrapper() {
  const { user, isUserDataLoading } = useAppSelector(state => state.auth);

  if (!user || isUserDataLoading) {
    return <Skeleton active />;
  }

  if ([Role.Clinician, Role.ClinicAdmin].includes(user.role)) {
    return <PatientHomeClinician />;
  }

  return <PatientHome patientId={user.uid} />;
}

function PatientHome(props: { patientId: string }) {
  const { state: patientInfo, refetch } = useGetPatientInfo(props.patientId);
  const patientCanStartAssessments = !!patientInfo.patient.canStartAssessments;

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 8
      }}
    >
      <BaseHeader headerStyle={{ background: 'none' }} />
      <PatientHomeLayout patientInfo={patientInfo}>
        {!patientCanStartAssessments && (
          <PatientHomeAssessmentBlockedV1Dot2
            patientInfo={patientInfo}
            refetchPatientInfo={refetch}
          />
        )}
        {patientCanStartAssessments && (
          <PatientHomeAssessmentUnblocked patientInfo={patientInfo} />
        )}
      </PatientHomeLayout>
    </div>
  );
}
